import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
// Limitless imports
import { log as pilog } from "@limitless/common/utils";
const LayoutContainer = ({
  classes,
  children,
  columns,
  fillAvailableSpace,
  align,
  columnStyles,
  indexStyles,
  gridStyles
}) => {
  const log = pilog.getLogger("LayoutContainer");
  const renderItem = (child, colStyles, index) => {
    const key = child && child.key ? child.key : index;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: classes.child,
      style: {
        ...colStyles
      }
    }, child);
  };
  const setAlign = () => {
    if (align === "center") {
      return {
        margin: "0 auto"
      };
    }
    if (align === "right") {
      return {
        marginLeft: "auto",
        marginRight: 0
      };
    }
    if (align === "left") {
      return {
        justifyItems: "left",
        marginRight: "auto",
        marginLeft: 0
      };
    }
    return {};
  };
  const setColumns = () => {
    let style = fillAvailableSpace ? "auto" : "min-content";
    for (let x = 1; x < columns; x++) {
      const columnStyle = columnStyles.find(cs => cs.column === x);
      if (columnStyle !== null && columnStyle !== void 0 && columnStyle.gridTemplateColumns) {
        style = `${columnStyle.gridTemplateColumns} ${style}`;
      } else {
        style = `${style} ${fillAvailableSpace ? "auto" : "min-content"}`;
      }
    }
    return {
      gridTemplateColumns: style
    };
  };
  const getStyles = index => {
    let colStyles = {};
    columnStyles.map(columnStyle => {
      const thisColumn = (index + 1) % columns === 0 ? columns : (index + 1) % columns;
      if (columnStyle.column === 0) {
        colStyles = {
          ...colStyles,
          ...columnStyle.styles
        };
      }
      if (columnStyle.column === thisColumn) {
        colStyles = {
          ...colStyles,
          ...columnStyle.styles
        };
      }
    });
    let indStyles = {};
    indexStyles.map(indexStyle => {
      if (indexStyle.index === index) {
        indStyles = {
          ...indStyles,
          ...indexStyle.styles
        };
      }
    });
    return {
      ...colStyles,
      ...indStyles
    };
  };
  const elements = Array.isArray(children) ? children : [children];
  return /*#__PURE__*/React.createElement("div", {
    className: columns === 0 ? classes.flex : classes.grid,
    style: {
      ...setColumns(),
      ...setAlign(),
      ...gridStyles
    }
  }, elements.map((child, index) => {
    try {
      return renderItem(child, getStyles(index), index);
    } catch (e) {
      log.debug(e);
    }
    return null;
  }));
};
const styles = {
  grid: {
    display: "grid",
    justifyItems: "center"
  },
  flex: {
    display: "flex",
    flexWrap: "wrap"
  },
  child: {
    marginRight: 16,
    marginBottom: 16
  }
};
export default withStyles(styles)(LayoutContainer);
LayoutContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
  classes: PropTypes.object.isRequired,
  columns: PropTypes.number,
  fillAvailableSpace: PropTypes.bool,
  align: PropTypes.string,
  indexStyles: PropTypes.array,
  columnStyles: PropTypes.array,
  gridStyles: PropTypes.object
};
LayoutContainer.defaultProps = {
  children: [],
  align: "left",
  columns: 2,
  gridStyles: {},
  indexStyles: [],
  columnStyles: [],
  fillAvailableSpace: true
};